import type { ApiClient } from '@treneo/infrastructure/api';
import { BaseApi } from '@treneo/infrastructure/api';
import type {
  IDatacenterModel,
  IGetConfigResponse,
  IGetCourseFormOptionsResponse,
  IGetTimezonesResponse,
  ISelectItem,
  ITimezoneModel,
  Result
} from '@treneo/models';

import { CONFIG_PATH } from '../../api-paths.constants';

export type OrganizationModel = {
  id: number;
  name: string;
  createdAt: string;
};

export class ConfigApi extends BaseApi {
  protected readonly baseUrl = CONFIG_PATH;

  constructor(apiClient: ApiClient) {
    super(apiClient);
  }

  getConfig = (): Promise<Result<IGetConfigResponse>> =>
    this.get<IGetConfigResponse>('', null, 'Get config failed');

  getCourseFormOptions = (): Promise<Result<IGetCourseFormOptionsResponse>> =>
    this.get<IGetCourseFormOptionsResponse>(
      '/course-form-options',
      null,
      'Get course form options failed'
    );

  getTimezones = (): Promise<Result<IGetTimezonesResponse>> =>
    this.get<IGetTimezonesResponse>('/timezones', null, 'Get timezones failed');

  datacentersToSelectItems(datacenters: IDatacenterModel[]): ISelectItem[] {
    return datacenters.map(datacenter => ({
      id: datacenter.id.toString(),
      label: datacenter.name,
      description: undefined
    }));
  }

  organizationsToSelectItems(organizations: OrganizationModel[]): ISelectItem[] {
    return organizations.map(organization => ({
      id: organization.id.toString(),
      label: organization.name,
      description: organization.createdAt
    }));
  }

  timezonesToSelectItems(timezones: ITimezoneModel[]): ISelectItem[] {
    return timezones.map(timezone => ({
      id: timezone.id,
      label: timezone.label,
      description: `IANA: ${timezone.id}`
    }));
  }
}
